import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { ForgotPasswordResolver } from "validators/UserValidation";

import { TextInput } from "shared/Components/textInput";
import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";
import AuthLayout from "shared/Components/authLayout";

import { client } from "helper/apolloConfig";
import { FORGET_PASSWORD_MUTATION } from "redux/features/passwordSlice/passwordGql";

const ForgotPassword = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    // reset,
  } = useForm({
    resolver: ForgotPasswordResolver,
    defaultValues: { email: "" },
  });
  const modalRef = useRef();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [loading, setLoading] = useState();
  const [getEmail, setGetEmail] = useState();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      email: values?.email,
    };
    setGetEmail(payload);
    try {
      const result = await client.mutate({
        mutation: FORGET_PASSWORD_MUTATION,
        variables: { data: payload },
      });
      if (result.data.forgetPassword.success) {
        modalRef.current.openModal();
        setApiData({
          title: globalVariables.otpCodeSuccess,
          desc: globalVariables.otpSuccessDescription,
          type: "success",
          actionButton: {
            label: "Enter Code",
            onClick: () => navigate("/otp", { state: { data: payload } }),
          },
        });
      }
      setLoading(false);
    } catch (error) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
      setLoading(false);
    }
  };

  const onCloseModal = () => {
    // No longer needed - action button handles navigation
  };
  return (
    <AuthLayout ref={modalRef} apiData={apiData} onCloseModal={onCloseModal}>
      <span className="pt-4 text-gray-900 font-semibold  text-3xl">
        {globalVariables.forgotPassword}
      </span>
      <span className="pt-3 text-gray-500 font-regular text-base text-center lg:w-[400px] md:w-[300px] w-[300px]">
        {globalVariables.sendResetLink}
      </span>
      <div className="mt-6" />
      <form
        onSubmit={handleSubmit((d) => console.log("d===", d))}
        className="max-[400px]:w-[90%]"
      >
        <TextInput
          register={register}
          name="email"
          label={globalVariables.email}
          placeholder={globalVariables.enterEmail}
          errorMsg={errors.email?.message}
          type="email"
          textTransform="normal-case"
        />
        <div className="mt-6" />
        <Button
          label={globalVariables.resetLink}
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        />
      </form>
      <div className="mt-4" />
      <span className="text-sm text-gray-600 font-regular">
        {globalVariables.rememberPassword}
        <a href="/login">
          <span className="text-sm text-primary font-semibold">
            {` ${globalVariables.logIn}`}
          </span>
        </a>
      </span>
    </AuthLayout>
  );
};

export default ForgotPassword;
